import { Component, Input, OnInit } from "@angular/core";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit {
  constructor() {}
  @Input() is_show_loader: boolean;

  ngOnInit(): void {}
}
